import React from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { PsdParseModalContainer } from './psd-parse-modal-container';
import { IPsdParseModalProps } from './type';

let root: Root | null = null;

export class PsdParseModal {
    static show(params: IPsdParseModalProps) {
        if (!document.getElementById('psd-parse-modal')) {
            const el = document.createElement('div');
            el.className = 'psd-parse-modal';
            el.id = 'psd-parse-modal';
            document.body.appendChild(el);
        }

        const newParams = {
            ...params,
            finishCallback: (data: any) => {
                if (params.finishCallback) {
                    params.finishCallback(data);
                }
                PsdParseModal.close();
            },

            closeCallback: () => {
                if (params.closeCallback) {
                    params.closeCallback();
                }
                PsdParseModal.close();
            },
        };

        const container = document.getElementById('psd-parse-modal') as HTMLElement;
        root = root || createRoot(container);
        root.render(<PsdParseModalContainer {...newParams} />);
    }

    static close() {
        root?.unmount();
        root = null;
    }
}
